var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.529 7.06713C21.8249 7.37914 21.0694 7.59074 20.2756 7.68521C21.0861 7.19983 21.7065 6.42996 22.0006 5.51542C21.2403 5.96491 20.4011 6.29129 19.5068 6.46822C18.7908 5.70432 17.7722 5.22852 16.6425 5.22852C14.4751 5.22852 12.7178 6.98586 12.7178 9.15205C12.7178 9.45927 12.7524 9.75934 12.8194 10.0463C9.55816 9.88247 6.66634 8.32 4.73087 5.94578C4.39255 6.5244 4.20008 7.19861 4.20008 7.91831C4.20008 9.27996 4.89346 10.4814 5.94548 11.1843C5.30231 11.1628 4.69739 10.9859 4.16782 10.6918V10.7408C4.16782 12.6416 5.5211 14.228 7.31548 14.589C6.98672 14.6775 6.64005 14.7265 6.2814 14.7265C6.02798 14.7265 5.7829 14.7014 5.5426 14.6536C6.04229 16.2137 7.49122 17.3482 9.20793 17.3793C7.86541 18.4313 6.17262 19.0565 4.334 19.0565C4.01721 19.0565 3.70517 19.0374 3.39795 19.0027C5.13497 20.1181 7.19716 20.7684 9.41356 20.7684C16.633 20.7684 20.5792 14.7887 20.5792 9.60275L20.5661 9.09469C21.3371 8.54473 22.0042 7.85376 22.529 7.06713Z",
    fill: "#6B767F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_925_6369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 20,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.529 7.06713C21.8249 7.37914 21.0694 7.59074 20.2756 7.68521C21.0861 7.19983 21.7065 6.42996 22.0006 5.51542C21.2403 5.96491 20.4011 6.29129 19.5068 6.46822C18.7908 5.70432 17.7722 5.22852 16.6425 5.22852C14.4751 5.22852 12.7178 6.98586 12.7178 9.15205C12.7178 9.45927 12.7524 9.75934 12.8194 10.0463C9.55816 9.88247 6.66634 8.32 4.73087 5.94578C4.39255 6.5244 4.20008 7.19861 4.20008 7.91831C4.20008 9.27996 4.89346 10.4814 5.94548 11.1843C5.30231 11.1628 4.69739 10.9859 4.16782 10.6918V10.7408C4.16782 12.6416 5.5211 14.228 7.31548 14.589C6.98672 14.6775 6.64005 14.7265 6.2814 14.7265C6.02798 14.7265 5.7829 14.7014 5.5426 14.6536C6.04229 16.2137 7.49122 17.3482 9.20793 17.3793C7.86541 18.4313 6.17262 19.0565 4.334 19.0565C4.01721 19.0565 3.70517 19.0374 3.39795 19.0027C5.13497 20.1181 7.19716 20.7684 9.41356 20.7684C16.633 20.7684 20.5792 14.7887 20.5792 9.60275L20.5661 9.09469C21.3371 8.54473 22.0042 7.85376 22.529 7.06713Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_925_6369)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.08344851025227581393c0c098273e90.svg";
export { ForwardRef as ReactComponent };